module.exports = __webpack_public_path__ + "static/go-7822b79248238f26d613261d292a9780.jpeg";